import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "mb-5",
  style: {"background-color":"#f8f8f8","padding":"20px"}
}
const _hoisted_2 = { class: "h5 fw-bold mb-3" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "mb-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t(
          `project.previewAndReport.reportTypes.${_ctx.reportType}.servicesOffered.title`
        )), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t(
              `project.previewAndReport.reportTypes.${_ctx.reportType}.servicesOffered.description`
            )), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t(
              `project.previewAndReport.reportTypes.${_ctx.reportType}.servicesOffered.additionalServices`
            )), 1)
      ])
    ])
  ]))
}